import { render, staticRenderFns } from "./SortFile.vue?vue&type=template&id=6db81f49&scoped=true&"
import script from "./SortFile.vue?vue&type=script&lang=js&"
export * from "./SortFile.vue?vue&type=script&lang=js&"
import style0 from "./SortFile.vue?vue&type=style&index=0&id=6db81f49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db81f49",
  null
  
)

export default component.exports